// extracted by mini-css-extract-plugin
module.exports = {"xxs":"0","xs":"450","sm":"630","md":"770","lg":"850","xl":"1000","xxl":"1345"};